/* src/app/features/contratacao/operacao/operacao-lote.component.scss */
.custom-file-input ~ .custom-file-label::after {
  content: "Selecionar";
}
.erros-upload {
  margin-top: 50px !important;
}
table {
  width: 90%;
}
textarea {
  font-size: 12px;
}
.obs-erro {
  margin-top: 5px !important;
  font-style: italic;
  font-size: 12px;
}
.arquivo-selecionado {
  font-size: 0.7rem;
  margin-top: 12px;
  color: blue;
}
/*# sourceMappingURL=operacao-lote.component.css.map */
